import DataStore from '@/engine/stores/data-store';

class PropertiesDataStore extends DataStore {

}

export default new PropertiesDataStore();
